import { render, staticRenderFns } from "./ComixGenreOverview.vue?vue&type=template&id=442b77f5&"
import script from "./ComixGenreOverview.vue?vue&type=script&lang=js&"
export * from "./ComixGenreOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports